<template>
  <div class="ship-details" :style="{ minHeight: 'calc(100vh - 60px)' }">
    <rCenterHeader :list="headerMenu"></rCenterHeader>
    <div class="details">
      <div class="title">
        {{ $t("shipment.logistics") }}: {{ details.code }}
      </div>
      <div class="common-flex">
        <div class="logistics">
          <div class="logistics-details common-flex common-justify-between">
            <div class="common-flex">
              <img class="logo" :src="details.expressUrl" alt=""/>
              <div
                class="
                  logistics-num
                  common-flex common-direction-column common-justify-around
                "
              >
                <div>{{ submitAddress.expressName }}</div>
                <div
                  class="common-flex"
                  style="font-size: 14px; font-weight: 400; opacity: 0.7"
                >
                  <span class="tag-read">{{ details.waybillNo!=='null'?details.waybillNo:'-' }}</span>
                  <!-- <span
                    @click="copy"
                    class="iconfont iconfuzhi common-hover"
                  ></span> -->
                </div>
              </div>
            </div>
            <div v-if="canEdit">
              <div
                class="edit common-flex common-justify-center common-hover"
                style="margin-bottom: 5px; background: #da8100; color: #fff"
                @click="editAddress"
              >
                <span class="iconfont iconbianji"></span>
                <span>{{ $t("shipment.editCurrentAdd") }}</span>
              </div>
              <div
                @click="chooseAddress"
                class="edit common-flex common-justify-center common-hover"
                style="background: #fbf2e5; color: #da8100"
              >
                <span class="iconfont iconbianji"></span>
                <span>{{ $t("shipment.chooseAnotherAdd") }}</span>
              </div>
            </div>
          </div>
          <div
            class="
              logistics-type
              common-flex common-align-center common-justify-between icons
            "
          >
            <div class="icons">
              {{ submitAddress.expressName }} /
              {{ submitAddress.expressTypeName }}
            </div>
             <div class="icons">{{ details.createTime?details.createTime:'' }}</div>
          </div>
          <div
            class="common-flex common-align-center"
            style="margin-bottom:10px"
          >
            <div style="margin-right:5px">{{ $t("order.deliveryDate") }}:</div>
            <form v-if="canEdit && details.status != 10372">
              <DatePicker
                v-if="details.shipdate"
                v-model="details.shipdate"
                type="date"
                @on-change="changeDate"
                :placeholder="$t('order.selectDate')"
                style="width: 200px"
              ></DatePicker>
            </form>
            <div v-else>{{ details.shipdate }}</div>
          </div>
          <div class="address">
            <div class="common-flex common-justify-between">
              <div>
                <div class="value">{{ submitAddress.contact }}</div>
                <div class="label">{{ $t("shipment.consignee") }}</div>
              </div>
              <div>
                <div class="value">{{ submitAddress.phone }}</div>
                <div class="label">{{ $t("shipment.phone") }}</div>
              </div>
            </div>
            <div>
              <div class="value">
                {{ submitAddress.countryName }}
                {{ submitAddress.provinceName }} {{ submitAddress.city }}
                {{ submitAddress.address }}
              </div>
              <div class="label">{{ $t("shipment.address") }}</div>
            </div>
            <div>
              <div class="value">
                {{ details.remark }}
              </div>
              <div class="label">{{ $t("shipment.remark") }}</div>
            </div>
          </div>
          <div
            class="logistics-information"
            v-if="details.trackList && details.trackList.length > 0"
          >
            <div
              class="logistics-information-item common-flex"
              v-for="(item, index) in details.trackList"
              :key="index"
            >
              <div class="information-item-line"></div>
              <div
                class="information-radio"
                :class="index == 0 ? 'information-radio-now' : ''"
              ></div>
              <div>
                <div class="item-time">{{ item.ftime }}</div>
                <div
                  :style="[index == 0 ? { color: '#0A4DCC' } : {}]"
                  class="item-address"
                >
                  {{ item.context }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="order">
          <div class="order-top common-flex common-justify-between">
            <div class="include-order">{{ $t("shipment.includeOrder") }}</div>
            <div class="add common-hover" @click="addOrder" v-if="canEdit">
              <Icon style="font-weight: 700" type="ios-add"/>
              {{ $t("shipment.addOrder") }}
            </div>
          </div>
          <div>
            <rShipmentOrder
              @delOrder="delOrder"
              :index="index"
              @details="detailModal"
              v-for="(item, index) in details.orderList"
              :config="item"
              :key="index"
              :canEdit="canEdit"
            ></rShipmentOrder>
            <rNull
              v-if="!details.orderList || details.orderList.length === 0"
              imgStyle="width:300px;margin:0 auto"
              titleStyle="font-size:16px;color:#999"
              :title="$t('noResult')"
            ></rNull>
            <div
              v-if="canEdit"
              class="common-flex common-flex-end ship-submit-box"
            >
              <Button @click="submitShips" class="ship-submit">{{
                  $t("shipment.submit")
                }}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <rAddOrder
      @back="backOrder"
      @submit="addOrders"
      :orders="orders"
      :deliveryCode="details.code"
      @close="closeFilte"
      :filteShow="addShow"
    ></rAddOrder>
    <!-- 取消订单弹框 -->
    <!-- <rConfirmModal
      :config="rConfirmModalConfig"
      :cancelShow="cancelShow"
      @handlerCancelShow="handlerCancelShow"
    ></rConfirmModal> -->
    <!-- 选择地址 -->
    <rChooseAddress
      :submitAddress="submitAddress"
      @submit="submit"
      @back="back"
      :addressShow="addressShow"
      @handlerAddressShow="handlerAddressShow"
    ></rChooseAddress>
    <Modal
      v-model="orderDetails"
      style="height: 90%"
      footer-hide
      fullscreen
      title=""
    >
      <div class="title-box">
        <div class="title">{{ $t("saveItems.CheckOptions") }}</div>
        <div
          @click="closeDetails"
          class="common-hover iconfont iconguanbi"
        ></div>
      </div>
      <rOrderDetails
        :config="orderMsg"
        :hideStep="true"
        detailsType="picture"
      ></rOrderDetails>
    </Modal>
    <rAddNewAddress
      :type="2"
      @saveConfirm="saveConfirm"
      :addressDetails="addressDetails"
      :addNew="addNew"
      @handlerAdd="handlerAdds"
    ></rAddNewAddress>
  </div>
</template>

<script>
import rCenterHeader from "../../components/r-center-header";
import rShipmentOrder from "../../components/r-shipment-order";
import rAddOrder from "../../components/r-add-order";
// import rConfirmModal from "../../components/r-confirm-modal";
import rChooseAddress from "../../components/r-choose-address-modal";
import rOrderDetails from "../../components/r-order-details";
import rNull from "../../components/r-null";
import rAddNewAddress from "../../components/r-add-new-address";
import {mapActions} from "vuex";
// import Clipboard from "clipboard";
export default {
  name: "ship-details",
  data() {
    return {
      submitShip: {
        shipdate: "", //计划发货日期
        remark: "", //备注
        orderIds: "", //发货订单id
        address: "", //地址信息
        id: ""
      },
      addNew: false,
      addressDetails: "",
      orderMsg: "",
      orderDetails: false,
      orders: "",
      submitAddress: "",
      details: "",
      addressShow: false,
      rConfirmModalConfig: {
        cancel: this.$t("shipment.no"),
        confirm: this.$t("shipment.yes"),
        content: this.$t("shipment.tipContent")
      },
      // 是否可编辑
      canEdit: false,
      cancelShow: false,
      // 新增显示
      addShow: false,
      // 头部面包屑
      headerMenu: [
        {
          name: this.$t("customer.crumbs.shipment"),
          to: "./shipment"
        },
        {
          name: this.$t("customer.crumbs.details")
        }
      ]
    };
  },
  mounted() {
    this.detailsShipping();
    this.submitShip.id = this.$route.query.id;
  },
  methods: {
    ...mapActions([
      "detailsShippingAction", //物流详情
      "getCartOrderDetailAction", //订单详情
      "selectOneAddressAction", //地址列表地址详情
      "putShippingAction", //提交发货
      "shippingAddressOneAction" //Shipping地址详情
    ]),
    // back
    backOrder() {
      this.addShow = false;
    },
    // 物流提交
    submitShips() {
      this.submitShip.address =
        this.submitAddress || this.addressDetails || this.details.address;
      this.submitShip.orderIds = "";
      this.details.orderList.map(item => {
        this.submitShip.orderIds =
          this.submitShip.orderIds + item.orderId + ",";
      });
      this.putShippingAction(this.submitShip).then(res => {
        if (res.code == 0) {
          this.$Message.success(res.message);
          this.$router.push("./shipment");
        }
      });
    },
    handlerAdds() {
      this.addNew = false;
    },
    // 点击保存
    saveConfirm(e) {
      this.addNew = false;
      this.details.remark = e.remark;
      this.addressDetails=e;
      this.submitAddress = e;
    },
    // 新增id
    addOrders(e) {
      this.details.orderList = this.details.orderList.concat(e);
      this.addShow = false;
    },
    // 跳转订单详情
    detailModal(e) {
      // this.$router.push("./orderDetails");
      this.orderDetails = true;
      this.getCartOrderDetailAction({
        orderId: e.orderId
      }).then(res => {
        this.orderMsg = res.data;
      });
    },
    delOrder(e, index) {
      this.$Modal.confirm({
        title: this.$t("delMsg.tips"),
        content: this.$t("delMsg.content"),
        okText: this.$t("delMsg.y"),
        cancelText: this.$t("delMsg.n"),
        onOk: async () => {
          this.details.orderList.splice(index, 1);
        }
      });
    },
    // 隐藏订单列表 操作
    closeDetails() {
      this.orderDetails = false;
    },
    // 返回
    back() {
      this.addressShow = false;
    },
    // 提交
    // submit(e){

    // },
    // 修改日期
    changeDate(e) {
      this.submitShip.shipdate = e;
    },
    // 物流详情
    detailsShipping() {
      this.detailsShippingAction({id: this.$route.query.id}).then(res => {
        this.details = res.data;
        this.submitShip.shipdate = res.data.shipdate;
        res.data.address.id = res.data.address.addressId;
        this.submitAddress = res.data.address;
        if (res.data.status == 10371 || res.data.status == 10372) {
          this.canEdit = true;
        } else {
          this.canEdit = false;
        }
      });
    },
    //   选择地址弹框显示
    chooseAddress() {
      this.addressShow = true;
    },
    //   取消弹框
    handlerAddressShow() {
      this.addressShow = false;
    },
    //  提交
    submit(e) {
      this.selectOneAddressAction({
        id: e
      }).then(res => {
        if (res.code == 0) {
          this.addressShow = false;
          this.addressDetails = res.data;
          // this.submitAddress.address = ''
          for (let key in this.submitAddress) {
            this.submitAddress[key] = res.data[key];
          }
        }
      });
    },
    //   隐藏取消弹框
    handlerCancelShow() {
      this.cancelShow = false;
    },
    // 编辑地址
    editAddress() {
      // 如果是选择了客户里的地址不做请求
      if (this.addressDetails) {
        this.addNew = true;
      } else {
        this.shippingAddressOneAction({id: this.details.id}).then(res => {
          if (res.code == 0) {
            this.addressDetails = res.data;
            this.addNew = true;
          }
        });
      }
    },
    //   复制
    copy() {
    },
    // 新增
    addOrder() {
      this.orders = "";
      this.details.orderList.map(item => {
        this.orders = this.orders + item.orderId + ",";
      });

      this.addShow = true;
    },
    // 关闭搜索分类
    closeFilte() {
      this.addShow = false;
    }
    // 提交
    // submit() {},
  },
  components: {
    rCenterHeader,
    rShipmentOrder,
    rAddOrder,
    // rConfirmModal,
    rChooseAddress,
    rOrderDetails,
    rAddNewAddress,
    rNull
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/ .ivu-icon-ios-close {
  display: none;
}

/deep/ .ivu-modal-body {
  padding: 0;
}

.title-box {
  height: 84px;
  text-align: center;
  font-size: 20px;
  font-family: Roboto;
  font-weight: 600;
  color: #081938;
  line-height: 84px;
  letter-spacing: 2px;
  // line-height: 84px;
  border-bottom: 1px solid #e6e8eb;
  position: relative;

  .iconguanbi {
    width: 84px;
    height: 84px;
    text-align: center;
    line-height: 84px;
    font-size: 14px;
    color: #081938;
    position: absolute;
    right: 0;
    top: 0;
    border-left: 1px solid #e6e8eb;
  }
}

.ship-details {
  .details {
    width: 1420px;
    margin: 0 auto 10px;
    padding: 20px 40px 23px 30px;
    background: #fff;

    .title {
      opacity: 0.7;
      font-size: 16px;
      font-family: Roboto, Roboto-Medium;
      font-weight: 500;
      text-align: left;
      color: #081938;
      line-height: 19px;
      margin: 20px 0 30px;
    }

    .logistics {
      // width: 371px;
      width: 447px;
      margin-right: 40px;
      border-right: 1px solid #f0f0f0;
      padding-right: 30px;

      .logistics-details {
        .logo {
          width: 65px;
          height: 65px;
          border-radius: 3px;
          background: #ffce3c;
          margin-right: 15px;
        }

        .logistics-num {
          font-size: 16px;
          font-family: Roboto;
          font-weight: 600;
          text-align: left;
          color: #081938;
          line-height: 19px;

          .iconfuzhi {
            margin-left: 8px;
            font-size: 12px;
          }
        }

        .edit {
          // padding: 0 12px;
          width: 142px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          background-color: #0a4dcc;
          border-radius: 2px;
          color: #fff;
          font-size: 12px;

          .iconbianji {
            font-size: 12px;
            margin-right: 5px;
            transform: scale(0.7);
          }
        }
      }

      .logistics-type {
        height: 23px;
        padding: 0 10px 0 12px;
        background: #f2f6fc;
        color: #0a4dcc;
        margin: 15px 0;

        .icons {
          font-size: 10px;
        }
      }

      .address {
        .value {
          opacity: 0.7;
          font-size: 14px;
          font-family: Roboto, Roboto-Regular;
          font-weight: 400;
          text-align: left;
          color: #081938;
          line-height: 20px;
          margin-bottom: 6px;
        }

        .label {
          opacity: 0.4;
          font-size: 12px;
          font-family: Roboto, Roboto-Regular;
          font-weight: 400;
          text-align: left;
          color: #081938;
          line-height: 14px;
          margin-bottom: 20px;
        }
      }

      .logistics-information {
        padding: 30px;
        background: #f8f8f8;
        border-radius: 3px;
        width: 331px;

        .logistics-information-item {
          position: relative;

          .information-radio {
            width: 8px;
            height: 8px;
            background: #979eaa;
            border-radius: 50%;
            margin-right: 17px;
            position: relative;
            z-index: 9;
          }

          .information-radio-now {
            position: relative;
          }

          .information-radio-now::after {
            content: "";
            width: 12px;
            height: 12px;
            background: #b0c4ea;
            left: -2px;
            top: -2px;
            position: absolute;
            border-radius: 50%;
          }

          .information-radio-now::before {
            content: "";
            width: 8px;
            height: 8px;
            background: #0a4dcc;
            left: 0px;
            top: -0.5px;
            position: absolute;
            border-radius: 50%;
            z-index: 10;
          }

          .information-item-line {
            position: absolute;
            height: 100%;
            width: 1px;
            left: 3.5px;
            top: 0px;
            background: #e6e6e6;
          }

          .item-time {
            opacity: 0.4;
            font-size: 12px;
            font-family: Roboto, Roboto-Regular;
            font-weight: 400;
            text-align: left;
            color: #081938;
            line-height: 14px;
            margin-bottom: 6px;
          }

          .item-address {
            opacity: 0.7;
            font-size: 12px;
            font-family: Roboto, Roboto-Regular;
            font-weight: 400;
            text-align: left;
            color: #081938;
            line-height: 14px;
            padding-bottom: 29px;
            width: 240px;
          }
        }
      }
    }

    .order {
      width: 897px;
      // width: 863px;
      // width: 977px;
      position: relative;

      .order-top {
        margin-bottom: 26px;

        .include-order {
          font-size: 14px;
          font-family: Roboto, Roboto-Bold;
          font-weight: 700;
          text-align: left;
          color: #081938;
          line-height: 16px;
          letter-spacing: 1px;
        }

        .add {
          font-size: 14px;
          font-family: Roboto, Roboto-Bold;
          font-weight: 700;
          text-align: left;
          color: #003888;
          line-height: 16px;
        }
      }
    }
  }

  .ship-submit-box {
    position: fixed;
    bottom: 60px;
    right: 60px;
  }

  .ship-submit {
    width: 110px;
    background: #0a4dcc;
    font-size: 16px;
    color: #fff;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shipment/shipmentDetails.vue